const initialState = {
	storeAvailabilityModalOpen: false
};

const availabilityReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'toggle-store-availability-modal':
			return { ...state, storeAvailabilityModalOpen: action.payload };
		default:
			return state;
	}
};

export default availabilityReducer;
